import {
  INTRANET_IMAGE_ALLOWED_MIME,
  INTRANET_VIDEO_ALLOWED_MIME,
  INTRANET_VIDEO_MAX_BYTES,
  intranetImageMaxMb,
} from '@gb-ticket/shared-types';

import { ApiRequestError } from '@/lib/api';

const IMAGES = new Set<string>(INTRANET_IMAGE_ALLOWED_MIME);
const VIDEOS = new Set<string>(INTRANET_VIDEO_ALLOWED_MIME);

/** Why a chosen cover cannot be uploaded, or null when the file is within the limit. */
export function coverFileIssue(file: File, imageMaxBytes: number): string | null {
  if (VIDEOS.has(file.type)) {
    if (file.size > INTRANET_VIDEO_MAX_BYTES) {
      return 'Das Video muss unter 12 MB bleiben.';
    }
    return null;
  }
  const maxMb = intranetImageMaxMb(imageMaxBytes);
  if (!IMAGES.has(file.type)) {
    return `Erlaubt sind JPEG, PNG und WebP bis ${maxMb} MB.`;
  }
  if (file.size > imageMaxBytes) {
    return `Das Bild darf höchstens ${maxMb} MB groß sein.`;
  }
  return null;
}

/**
 * Text for a failed cover request. A proxy often answers 400 or 413 without the API envelope
 * when the body exceeds the server limit.
 */
export function coverFailureMessage(caught: unknown, imageMaxBytes: number): string {
  const limit = `Das Bild darf höchstens ${intranetImageMaxMb(imageMaxBytes)} MB groß sein.`;
  if (!(caught instanceof ApiRequestError)) {
    return 'Das Titelbild konnte nicht hochgeladen werden.';
  }
  const { code, statusCode, message } = caught.error;
  if (code === 'FILE_TOO_LARGE' || statusCode === 413) {
    if (
      message.startsWith('Das Bild') ||
      message.startsWith('Das Video') ||
      message.startsWith('Erlaubt sind')
    ) {
      return message;
    }
    return limit;
  }
  if (code === 'UNKNOWN' && (statusCode === 400 || statusCode === 413)) {
    return limit;
  }
  return message;
}
